<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.group_index,
                    },
                    {
                        name: group.name,
                        href: meta.links.group_show,
                    },
                    {
                        name: $t('messages.results_per_student'),
                        href: null,
                    },
                ]"
            >
                <template v-slot:corner>
                    <div>
                        <ActivityMenuOptions>
                            <InertiaLink
                                v-for="otherStudent in meta.links.otherStudents"
                                :href="otherStudent.url"
                                :key="otherStudent.url"
                                class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                role="menuitem"
                            >
                                {{ otherStudent.text }}
                            </InertiaLink>
                        </ActivityMenuOptions>
                    </div>
                </template>
            </SmartBreadcrumbs>
        </template>

        <div class="w-full flex space-x-4 justify-end">
            <AppButton element="InertiaLink" :href="meta.links.tag_attempts_index">
                {{ $t('messages.results_per_tag') }}
            </AppButton>
        </div>

        <EmptyState v-if="subjects.length === 0" picture />
        <div v-else class="flex flex-wrap gap-x-2">
            <AppButton
                element="InertiaLink"
                :href="subject.url"
                v-for="subject in subjects"
                :key="subject.id"
                class="flex gap-x-2"
            >
                {{ subject.text }}

                <IconCircleCheckFilled class="h-5 w-5 text-indigo-600" v-if="filters.subject_id == subject.id" />
            </AppButton>
        </div>

        <form :action="meta.links.index" method="GET" @submit.prevent="filter">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 md:grid-cols-12">
                <div class="sm:col-span-2">
                    <div class="mt-1" v-if="options.contentBlocks.length">
                        <FormLabel :value="$tc('messages.content_blocks', 1)" for="content_block_id" />
                        <FormSelect
                            id="subject_id"
                            v-model="form.content_block_id"
                            :options="options.contentBlocks"
                            class="mt-1 w-full"
                        />
                        <FormError :value="form.errors.content_block_id" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <div class="mt-1" v-if="options.tags.length">
                        <FormLabel :value="$tc('messages.tags', 1)" for="question_tag_id" />
                        <FormSelect
                            id="question_tag_id"
                            v-model="form.question_tag_id"
                            :options="options.tags"
                            class="mt-1 w-full"
                        />
                        <FormError :value="form.errors.question_tag_id" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.activity_mode')" for="mode" />
                        <FormSelect
                            required
                            id="mode"
                            v-model="form.mode"
                            :options="options.modes"
                            class="mt-1 w-full"
                            :null-option-text="$t('messages.all')"
                        />
                        <FormError :value="form.errors.mode" class="mt-2" />
                    </div>
                </div>
            </div>
        </form>

        <div v-if="!!form.question_tag_id">
            <div v-for="graph in graphs" :key="graph.id">
                <div v-if="graph.graph_type === 'sortable'">
                    <GradesBarGraphSortable
                        :input-series="graph.options.series[0]"
                        :input-options="graph.options"
                        :non-alphabetical-order="graph.nonAlphabeticalOrder"
                    />
                </div>
                <div v-else>
                    <apexchart
                        :type="graph.options.chart.type"
                        :height="graph.options.chart.height"
                        :series="graph.options.series"
                        :options="graph.options"
                    />
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import EmptyState from '@/components/EmptyState.vue';
import AppButton from '@/components/AppButton.vue';
import { IconCircleCheckFilled } from '@tabler/icons-vue';
import ActivityMenuOptions from '@/components/pageSpecific/ActivityMenuOptions.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import GradesBarGraphSortable from '@/components/pageSpecific/GradesBarGraphSortable.vue';

export default {
    components: {
        GradesBarGraphSortable,
        FormLabel,
        FormError,
        FormSelect,
        ActivityMenuOptions,
        AppButton,
        PanelPage,
        EmptyState,
        IconCircleCheckFilled,
    },
    layout: Layout,
    name: 'Index',
    props: ['subjects', 'options', 'filters', 'group', 'meta', 'graphs'],
    data() {
        return {
            form: this.$inertia.form({
                subject_id: this.filters.subject_id,
                content_block_id: this.filters.content_block_id,
                question_tag_id: this.filters.question_tag_id,
                mode: this.filters.mode,
            }),
        };
    },
    watch: {
        'form.content_block_id': function () {
            this.form.question_tag_id = null;
            this.filter();
        },
        'form.question_tag_id': function () {
            this.filter();
        },
        'form.mode': function () {
            this.filter();
        },
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
